import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const notifyPeerSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({        
        postNotifyPeer: builder.mutation({
                    query: (arg: any) => ({
                        url: constants.NOTIFY_PEER,
                        method: 'POST',
                        body: arg,
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                        },
                    }),
                }),
    }),
});

export const { usePostNotifyPeerMutation } = notifyPeerSlice;
